// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"277":"7282d09c","453":"51ca8dfe","833":"bb655f9f"}[chunkId] + ".chunk.js";
};